const EQUALITY_WITHOUT_VALUE = ['missing', 'not-missing']

export function compareRules(ruleCompare, rule) {
  const { equality: ruleEquality } = rule
  const { equality: compareEquality } = ruleCompare
  if (rule.type === 'integer') ruleCompare.value = parseInt(ruleCompare.value)
  if (ruleCompare.type === 'integer') rule.value = parseInt(rule.value)

  const case1 = ruleEquality === 'equal' && compareEquality === 'equal'
  const case2 = ((ruleEquality === 'lt' || ruleEquality === 'le') && (compareEquality === 'gt' || compareEquality === 'ge')) && (rule.value < ruleCompare.value)
  const case3 = ((compareEquality === 'lt' || compareEquality === 'le') && (ruleEquality === 'gt' || ruleEquality === 'ge')) && (ruleCompare.value < rule.value)
  const case4 = (ruleEquality === 'equal' || ruleEquality === 'not-equal') && (compareEquality === 'equal' || compareEquality === 'not-equal') && ruleEquality !== compareEquality
  const case5 = (ruleEquality === 'equal' || compareEquality === 'equal') && (compareEquality === 'lt' || ruleEquality === 'lt' || compareEquality === 'gt' || ruleEquality === 'gt')
  const case6 = (ruleEquality === 'lt' || ruleEquality === 'gt') && (compareEquality === 'lt' || compareEquality === 'gt')
  const case7 = ((ruleEquality === 'missing' && compareEquality === 'not-missing') || (ruleEquality === 'not-missing' && compareEquality === 'missing'))
  const case8 = (ruleEquality === 'included' && compareEquality === 'excluded' && ruleCompare.value == rule.value) || (ruleEquality === 'excluded' && compareEquality === 'included' && ruleCompare.value == rule.value)
  const case9 = (ruleEquality === 'contains' && compareEquality === 'excluded' && ruleCompare.value == rule.value) || (ruleEquality === 'excluded' && compareEquality === 'contains' && ruleCompare.value == rule.value)
  const case10 = (ruleEquality === 'equal' && compareEquality === 'missing') || (ruleEquality === 'missing' && compareEquality === 'equal')

  if (case10) return true

  if (case9) return true

  if (case8) return true

  if (case7) return true

  if (case1 && (ruleCompare.value != rule.value)) {
    return true
  }

  if (case2 || case3) {
    return true
  }

  if (ruleCompare.value === rule.value) {
    if (case4) {
      return true
    }

    if (case5) {
      return true
    }

    if (case6) {
      return true
    }
  }

  return false
}

export function verifyConflict({ rule, ruleIdx, groupCondition, groupIdx, rules }) {
  const { key, value, equality, type } = rule
  const { groups, condition: rootCondition } = rules

  if (!key || !equality || !type || (!EQUALITY_WITHOUT_VALUE.includes(equality) && (!value && type !== 'boolean'))) {
    return null
  }

  for (let currentGroupIdx = 0; currentGroupIdx < groups.length; currentGroupIdx++) {
    const { rules: groupRules } = groups[currentGroupIdx];
    for (let currentRuleIdx = 0; currentRuleIdx < groupRules.length; currentRuleIdx++) {
      const ruleCompare = groupRules[currentRuleIdx]
      const { key, value, equality, type } = ruleCompare

      if (!key || !equality || !type || (!EQUALITY_WITHOUT_VALUE.includes(equality) && (!value && type !== 'boolean'))) {
        continue
      }

      const skip = ((groupCondition === 'or' || groupCondition === 'none') && (groupIdx === currentGroupIdx)) ||
        ((rootCondition === 'or' || rootCondition === 'none') && groupIdx !== currentGroupIdx) ||
        (rule.key !== ruleCompare.key) ||
        (currentRuleIdx === ruleIdx && currentGroupIdx === groupIdx)
      if (skip) continue

      return compareRules(ruleCompare, rule)
    }
  }

  return false
}

export default function useConflict() {
  return {
    handleConflict: verifyConflict
  }
}
